// Georgetown University's undergraduate majors (#2743). Read on 2026-10-01
// from the official 2026-2027 University Bulletin (bulletin.georgetown.edu):
// each school's Colleges and Schools page, which links its programs, with
// the degree taken from the bulletin's Programs list (AB, BS, BSFS, BSBA,
// BSN). Every bachelor's program linked from the six schools first-year
// applicants apply to is kept, each once: Public Policy sits under the
// McCourt School (a joint AB with the College), Business and Global Affairs
// under the Walsh School of Foreign Service, and International Business,
// Language and Culture under the College (both joint with McDonough; the
// admissions Schools and Majors page says students apply to them at the end
// of the first year). Left out: the School of Continuing Studies' Liberal
// Studies (BALS), which first-year applicants do not apply to, and the
// Qatar campus's BSFS programs, which the main-campus school pages do not
// link. The KB's majors list was the starting point; the bulletin wins.
const majors = {
    "slug": "georgetown-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Georgetown's official 2026-2027 University Bulletin for the undergraduate schools first-year students apply to, grouped by school, with the degree it leads to. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts & Sciences",
            "source": {
                "label": "Georgetown 2026-2027 University Bulletin, College of Arts & Sciences",
                "url": "https://bulletin.georgetown.edu/colleges-schools/college-arts-sciences/"
            },
            "majors": [
                {
                    "name": "American Musical Cultures",
                    "degree": "AB"
                },
                {
                    "name": "American Studies",
                    "degree": "AB"
                },
                {
                    "name": "Anthropology",
                    "degree": "AB"
                },
                {
                    "name": "Arabic",
                    "degree": "AB"
                },
                {
                    "name": "Art",
                    "degree": "AB"
                },
                {
                    "name": "Art History",
                    "degree": "AB"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biological Physics",
                    "degree": "AB"
                },
                {
                    "name": "Biological Physics",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biology of Global Health",
                    "degree": "BS"
                },
                {
                    "name": "Black Studies",
                    "degree": "AB"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chinese",
                    "degree": "AB"
                },
                {
                    "name": "Classics",
                    "degree": "AB"
                },
                {
                    "name": "Computer Science",
                    "degree": "AB"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science, Ethics & Society",
                    "degree": "AB"
                },
                {
                    "name": "Disability Studies",
                    "degree": "AB"
                },
                {
                    "name": "East Asian Languages & Cultures",
                    "degree": "AB"
                },
                {
                    "name": "Economics",
                    "degree": "AB"
                },
                {
                    "name": "English",
                    "degree": "AB"
                },
                {
                    "name": "Environment & Sustainability",
                    "degree": "BS",
                    "note": "A joint program with the Earth Commons Institute; you apply to it directly."
                },
                {
                    "name": "Environmental Biology",
                    "degree": "BS"
                },
                {
                    "name": "French & Francophone Studies",
                    "degree": "AB"
                },
                {
                    "name": "German",
                    "degree": "AB"
                },
                {
                    "name": "Global & Comparative Literature",
                    "degree": "AB"
                },
                {
                    "name": "Global Medieval Studies",
                    "degree": "AB"
                },
                {
                    "name": "Government",
                    "degree": "AB"
                },
                {
                    "name": "History",
                    "degree": "AB"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "AB"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BS"
                },
                {
                    "name": "International Business, Language & Culture",
                    "degree": "BS",
                    "flag": "A joint major with the McDonough School of Business. Students apply to enter at the end of their first year.",
                    "flagSource": "schools"
                },
                {
                    "name": "Italian",
                    "degree": "AB"
                },
                {
                    "name": "Japanese",
                    "degree": "AB"
                },
                {
                    "name": "Justice & Peace Studies",
                    "degree": "AB"
                },
                {
                    "name": "Korean",
                    "degree": "AB"
                },
                {
                    "name": "Linguistics",
                    "degree": "AB"
                },
                {
                    "name": "Mathematics",
                    "degree": "AB"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Neurobiology",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "AB"
                },
                {
                    "name": "Physics",
                    "degree": "AB"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Economy",
                    "degree": "AB"
                },
                {
                    "name": "Portuguese",
                    "degree": "AB"
                },
                {
                    "name": "Psychology",
                    "degree": "AB"
                },
                {
                    "name": "Sociology",
                    "degree": "AB"
                },
                {
                    "name": "Spanish",
                    "degree": "AB"
                },
                {
                    "name": "Spanish & Portuguese Studies",
                    "degree": "AB"
                },
                {
                    "name": "Theater & Performance Studies",
                    "degree": "AB"
                },
                {
                    "name": "Theology & Religious Studies",
                    "degree": "AB"
                },
                {
                    "name": "Women's & Gender Studies",
                    "degree": "AB"
                }
            ]
        },
        {
            "name": "Walsh School of Foreign Service",
            "source": {
                "label": "Georgetown 2026-2027 University Bulletin, Walsh School of Foreign Service",
                "url": "https://bulletin.georgetown.edu/colleges-schools/school-foreign-service/"
            },
            "majors": [
                {
                    "name": "Business & Global Affairs",
                    "degree": "BS",
                    "flag": "A joint major with the McDonough School of Business. Students apply to enter at the end of their first year.",
                    "flagSource": "schools"
                },
                {
                    "name": "Culture & Politics",
                    "degree": "BSFS"
                },
                {
                    "name": "Global Business",
                    "degree": "BSFS"
                },
                {
                    "name": "International Economics",
                    "degree": "BSFS"
                },
                {
                    "name": "International History",
                    "degree": "BSFS"
                },
                {
                    "name": "International Political Economy",
                    "degree": "BSFS"
                },
                {
                    "name": "International Politics",
                    "degree": "BSFS"
                },
                {
                    "name": "Regional & Comparative Studies",
                    "degree": "BSFS"
                },
                {
                    "name": "Science, Technology, & International Affairs",
                    "degree": "BSFS"
                }
            ]
        },
        {
            "name": "McDonough School of Business",
            "source": {
                "label": "Georgetown 2026-2027 University Bulletin, McDonough School of Business",
                "url": "https://bulletin.georgetown.edu/colleges-schools/mcdonough-school-business/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BSBA"
                },
                {
                    "name": "Finance",
                    "degree": "BSBA"
                },
                {
                    "name": "International Business Regional Studies",
                    "degree": "BSBA"
                },
                {
                    "name": "International Political Economy & Business",
                    "degree": "BSBA"
                },
                {
                    "name": "Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BSBA"
                },
                {
                    "name": "Operations & Analytics",
                    "degree": "BSBA"
                }
            ]
        },
        {
            "name": "Berkley School of Nursing",
            "source": {
                "label": "Georgetown 2026-2027 University Bulletin, Berkley School of Nursing",
                "url": "https://bulletin.georgetown.edu/colleges-schools/berkley-school-nursing/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                },
                {
                    "name": "Post Bachelors in Nursing",
                    "degree": "BSN",
                    "note": "For students who already hold a bachelor's degree."
                }
            ]
        },
        {
            "name": "School of Health",
            "source": {
                "label": "Georgetown 2026-2027 University Bulletin, School of Health",
                "url": "https://bulletin.georgetown.edu/colleges-schools/school-health/"
            },
            "majors": [
                {
                    "name": "Global Health",
                    "degree": "BS"
                },
                {
                    "name": "Healthcare Management & Policy",
                    "degree": "BS"
                },
                {
                    "name": "Human Science",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "McCourt School of Public Policy",
            "source": {
                "label": "Georgetown 2026-2027 University Bulletin, McCourt School of Public Policy",
                "url": "https://bulletin.georgetown.edu/colleges-schools/mccourt-school-public-policy/"
            },
            "majors": [
                {
                    "name": "Public Policy",
                    "degree": "AB",
                    "note": "A joint degree with the College of Arts & Sciences; you apply to it directly."
                }
            ]
        }
    ]
};

export default majors;
